import { render, staticRenderFns } from "./EditCell.vue?vue&type=template&id=64495698&scoped=true&"
import script from "./EditCell.vue?vue&type=script&lang=js&"
export * from "./EditCell.vue?vue&type=script&lang=js&"
import style0 from "./EditCell.vue?vue&type=style&index=0&id=64495698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64495698",
  null
  
)

export default component.exports